import { useEffect, useState } from 'react';
import { useDatabase } from './useDatabase';

export interface DecisionDetails {
  id: string;
  title: string;
  choices: string[];
  exclusive: boolean;
}

export function useDecision(decisionId: string | undefined) {
  const { database, loading: databaseLoading } = useDatabase();
  const [decision, setDecision] = useState<DecisionDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database || !decisionId) {
      if (!database) setLoading(false);
      return;
    }

    try {
      const decisions = database.decisions();
      const obj = decisions[decisionId];

      if (!obj) {
        setError(`Decision with ID ${decisionId} not found`);
        setDecision(null);
      } else {
        setDecision({
          id: decisionId,
          title: obj.title(),
          choices: obj.choices(),
          exclusive: obj.exclusive(),
        });
        setError(null);
      }
    } catch (err) {
      console.error('Error fetching decision:', err);
      setError(`Error fetching decision: ${err}`);
      setDecision(null);
    } finally {
      setLoading(false);
    }
  }, [database, decisionId]);

  return { decision, loading: loading || databaseLoading, error };
}
